import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class StoneBridgeTileEntity2 extends TileEntity {
	public static readonly frameName = FrameName.STONE_BRIDGE_2;
}

export default StoneBridgeTileEntity2;
